import type { FC } from 'react'
import { useTheme } from '@emotion/react'

import styled from '@emotion/styled'

import sanitizeHtml from 'sanitize-html'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import useMatchMedia from '@segment/utils/useMatchMedia'

interface WhyDoYouNeedProps {
  heading: string
  copy: {
    paragraph: string
  }[]
}

const WhyDoYouNeed: FC<WhyDoYouNeedProps> = ({ heading, copy }) => {
  const theme = useTheme()
  const mobileResolutionMediaQuery = theme.breakpoints.down(`md`, true)
  const isSmallResolution = useMatchMedia(mobileResolutionMediaQuery, true)

  return (
    <StyledSectionBase variant="centered">
      <Section.Copy>
        <StyledCopyTextBase centered={!isSmallResolution}>
          <CopyText.Heading tag="h2">{heading}</CopyText.Heading>
          {copy.map((text, index) => (
            <CopyText.Description
              key={index}
              tag="p"
              variant="pLarge"
              dangerouslySetInnerHTML={{
                __html: sanitizeHtml(text.paragraph, { allowedTags: [`a`] }),
              }}
            />
          ))}
        </StyledCopyTextBase>
      </Section.Copy>
    </StyledSectionBase>
  )
}

const StyledSectionBase = styled(SectionBase)`
  ${Section.Wrapper} {
    padding-bottom: 0;
    ${({ theme }) => theme.breakpoints.up(`lg`)} {
      padding-bottom: 40px;
    }
  }
`

const StyledCopyTextBase = styled(CopyTextBase)`
  text-align: start;
  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    text-align: center;
  }
`

export default WhyDoYouNeed
